import script from "./DomainHistoryDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainHistoryDataTable.vue?vue&type=script&setup=true&lang=js"

import "./DomainHistoryDataTable.vue?vue&type=style&index=0&id=cb70dc6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb70dc6a"]])

export default __exports__